const actions = {
  My_DONATIONS_REQUEST: "My_DONATIONS_REQUEST",
  MY_DONATIONS_SUCCESS: "MY_DONATIONS_SUCCESS",
  MY_DONATIONS_ERROR: "MY_DONATIONS_ERROR",

  DOWNLOAD_PDF_REQUEST: "DOWNLOAD_PDF_REQUEST",
  DOWNLOAD_PDF_SUCCESS: "DOWNLOAD_PDF_SUCCESS",
  DOWNLOAD_PDF_ERROR: "DOWNLOAD_PDF_ERROR",

  GET_YEAR_REQUEST: "GET_YEAR_REQUEST",
  GET_YEAR_SUCCESS: "GET_YEAR_SUCCESS",
  GET_YEAR_ERROR: "GET_YEAR_ERROR",
  RESET_ACTIONTYPE:"RESET_ACTIONTYPE",

  getMyDonationsList: (url) => ({
    type: actions.My_DONATIONS_REQUEST,
    payload: { url },
  }),

  downloadPDF: (url) => ({
    type: actions.DOWNLOAD_PDF_REQUEST,
    payload: { url },
  }),

  getYEAR: (url) => ({
    type: actions.GET_YEAR_REQUEST,
    payload: { url },
  }),

  resetActionType: () => {
    return {
      type: actions.RESET_ACTIONTYPE,
    }
  },
};

export default actions;
